export const COLORS = {
	WHATSAPP: '#5FC95C',
	SUCESS_GREEN: '#429d75',
	LINK_COLOR: '#3273dc',
	ERROR_COLOR: '#e55353',
	INSTAGRAM_BUTTON_COLOR: '#DE4764',
	FACEBOOK_BUTTON_COLOR: '#1877f2',
	PENDING_STATUS: '#F1C233',
	APP_BASE_COLOR: '#4a74c9',
	EXCEL: '#32764E',
};

export const BASE_COLORS = {
	WHITE: '#fff',
	GREY: '#898989',
	BLACK: '#000',
	BLUE: '#0089D2',
	GREEN: '#5BB123',
	LIGHT_GREY_1: '#E0E0E0',
	LIGHT_GREY_2: '#f2f2f2',
	LIGHT_GREY_3: '#FAFAFA',
	LIGHT_RED_1: '#f26060',
	LIGHT_RED_2: '#f9b8b8',
	LIGHT_BLACK_1: '#494949',
	LIGHT_BLACK_2: '#5b5b5b',
	LIGHT_ORANGE: '#fcece3',
};
